import { Alert, Box, Button, Icon, Stack } from "@mui/material";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
    AccountService,
    GatewayNumberStatus,
    SmsCampaignDto,
    SmsCampaignService,
} from "../../../api/psc";
import {
    CardInformation,
    DialogContainer,
    DialogHeader,
    Spinner,
} from "../../../components/exports";
import { RootState } from "../../../slices/Store";

// updated
export default function SmsCampaignFilterCalculationResult() {
    const campaignState = useSelector((r: RootState) => r.smsCampaign);

    const [dryRunSmsCampaign, setDryRunSmsCampaign] =
        useState<SmsCampaignDto | null>(null);
    const [availablePartCount, setAvailablePartCount] = useState(0);

    useEffect(() => {
        const publicGatewayNumbers = campaignState.gatewayNumbers.filter(
            (gn) => gn.status === GatewayNumberStatus.PUBLIC
        );

        let gatewayNumberId: number | null = null;

        if (publicGatewayNumbers) {
            gatewayNumberId = publicGatewayNumbers[0].id;
        }

        Promise.all([
            SmsCampaignService.createSmsCampaign("1", {
                projectFilterDestinations: [campaignState.projectFilter],
                definition: {
                    ...campaignState.definition,
                    gatewayNumberId: gatewayNumberId,
                    dryRun: true,
                },
            }),
            AccountService.getAccountDetail("1"),
        ]).then((r) => {
            setDryRunSmsCampaign(r[0]);
            setAvailablePartCount(r[1].partCount);
        });
    }, []);

    return (
        <DialogContainer>
            <DialogHeader title="محاسبه تعداد پیامک" />

            {dryRunSmsCampaign === null && <Spinner />}

            {dryRunSmsCampaign !== null && (
                <Box sx={{ p: 2 }}>
                    <Stack spacing={2}>
                        <CardInformation
                            title={"تعداد پارت"}
                            value={dryRunSmsCampaign.totalPartCount}
                        />
                        <CardInformation
                            title={"تعداد پیامک"}
                            value={dryRunSmsCampaign.totalSmsCount}
                        />
                        <CardInformation
                            title={"پارت پیامکی حساب"}
                            value={availablePartCount}
                        />

                        {availablePartCount >=
                            dryRunSmsCampaign.totalPartCount && (
                            <Alert sx={{ my: 2 }} severity="success">
                                شما برای اجرای این کمپین شارژ کافی دارید
                            </Alert>
                        )}

                        {availablePartCount <
                            dryRunSmsCampaign.totalPartCount && (
                            <>
                                <Alert sx={{ my: 2 }} severity="warning">
                                    شما برای اجرای این کمپین شارژ کافی ندارید
                                </Alert>
                                <a target="_blank" href={"/store"}>
                                    <Button
                                        fullWidth
                                        variant="contained"
                                        startIcon={<Icon>shopping_bag</Icon>}
                                    >
                                        خرید شارژ
                                    </Button>
                                </a>
                            </>
                        )}
                    </Stack>
                </Box>
            )}
        </DialogContainer>
    );
}
